import React, {useEffect} from 'react'
import './MobileHandler.sass'
import {useTranslation} from "react-i18next";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from 'react-device-detect'
import { apiUser } from '../basedata/apiCall';
import { buildFlowQuery, isEvent, syncCredFlag } from '../basedata/constants'
import QRCode from '../components/QRCode/QRCode'
import AlertCard from '../components/AlertCard/AlertCard';

const MobileHandler = () => {
  const [currentUrl, setCurrentUrl] = React.useState(window.location.origin)
  const [userToken, setUserToken] = React.useState('')
  const [originCompany, setOriginCompany] = React.useState('')
  const { t } = useTranslation()
  const [showAlert, setShowAlert] = React.useState(false)
  const mobileHandlerKeyPrefix = isEvent()
    ? "event.mobile_handler"
    : "mobile_handler";
  const getMobileTargetUrl = (token?: string | null, orc?: string | null, cred?: string | null) =>
    `${window.location.origin}/mobile-handler?${buildFlowQuery({ token, orc, cred })}`;

  const [name, setName] = React.useState<string | null>(localStorage.getItem('name'));


  useEffect(() => {

    const params = new URLSearchParams(window.location.search)
    const currentToken:any = params.get('token');
    const currentOrc:any = params.get('orc');
    const currentCred:any = params.has('cred') ? params.get('cred') : 'false';

    if(currentToken){
      console.log(currentToken)
      syncCredFlag(currentCred)
      sessionStorage.setItem('token', currentToken )
      sessionStorage.setItem('orc', currentOrc )

      const fullUrl = getMobileTargetUrl(currentToken, currentOrc, currentCred);

      navigator.clipboard.writeText(fullUrl).then(() => {
        console.log('Link copiado para a área de transferência:', fullUrl);
      }).catch(err => {
        console.error('Erro ao copiar o link:', err);
      });
    }


    if(currentToken || window.sessionStorage.getItem('token')){
      if(isMobile){
        window.location.href = `/instructions?${buildFlowQuery({
          token: currentToken || window.sessionStorage.getItem('token'),
          orc: currentOrc || window.sessionStorage.getItem('orc'),
          cred: currentCred || window.sessionStorage.getItem('cred')
        })}`
      }
    }

    if (window.sessionStorage.getItem('token')) {
      setUserToken(window.sessionStorage.getItem('token') + '')
      setOriginCompany(window.sessionStorage.getItem('orc') + '')
    }

    const handleNameChange = () => {
        const updatedName = localStorage.getItem('name');
        setName(updatedName);
      };

      window.addEventListener('nameChanged', handleNameChange);

      return () => {
        window.removeEventListener('nameChanged', handleNameChange);
      };
  }, [])

  const verifyBiometry = async (userToken:any) => {
    try{
      const _response = await apiUser.post(`/biometry/onboarding/user-jorney`, {flowId: userToken})

      if(_response.data.status === 'success'){
        const _current_location = window.location.pathname
        if(_response.data.message === 'done'){
          if(!/success/.test(_current_location)){
            window.location.href = 'success'
          }
        }
      }

      setTimeout(() => {
        verifyBiometry(userToken)
      }, 3000);
    }catch(e){
      setTimeout(() => {
        verifyBiometry(userToken)
      }, 3000);
    }
  }

  const link = getMobileTargetUrl(userToken, originCompany, sessionStorage.getItem('cred'));

  useEffect(() => {
    verifyBiometry(window.sessionStorage.getItem('token'))
  }, [])
    return (

      <div className='card-instructions'>
        {showAlert && (
          <AlertCard
            title={t("well_done_document.front_default_title")}
            message={t("signup.messages.alert_info")}
            onClose={() => setShowAlert(false)}
          />
        )}
      <h1 className='bepass-title'>{t(`${mobileHandlerKeyPrefix}.instruction_title`)}</h1>
      <p className='bepass-text-default'>{t(`${mobileHandlerKeyPrefix}.instruction_text`)}</p>
      <div className="qr-code">
           <QRCode
            value={link}
          />
        </div>
        <p className="bepass-text-label">
          {t(`${mobileHandlerKeyPrefix}.instruction_link_label`) + " "}
          <a
            className="qr-link"
            href={link}
            onClick={(e) => {
              e.preventDefault();
              navigator.clipboard.writeText(link)
                .then(() => {
                  console.log('Link copiado com sucesso!');
                })
                .catch(err => {
                  console.error('Erro ao copiar o link:', err);
                });
              setShowAlert(true);
            }}
          >
            {link}
          </a>.
        </p>
      </div>
    )
}
export default MobileHandler
